import { http } from '@/http/axios.js'
// list
export function getListAPI(params) {
  return http({
    url: '/admin/oprt/ad/page',
    method: 'get',
    params
  })
}
// delete
export function deleteOprtAdAPI(id) {
  return http({
    url: '/admin/oprt/ad/delete',
    method: 'post',
    data: { id }
  })
}
// add
export function addOprtAdAPI(data) {
  return http({
    url: '/admin/oprt/ad/add',
    method: 'post',
    data
  })
}
// edit
export function editOprtAdAPI(data) {
  return http({
    url: '/admin/oprt/ad/edit',
    method: 'post',
    data
  })
}
// detail
export function getOprtAdDetailAPI(id) {
  return http({
    url: '/admin/oprt/ad/detail',
    method: 'get',
    params: { id }
  })
}
// status
export function changeStatusAPI(data) {
  return http({
    url: '/admin/oprt/ad/status',
    method: 'post',
    data
  })
}
//weight
export function changeWeightAPI(data) {
  return http({
    url: '/admin/oprt/ad/weight',
    method: 'post',
    data
  })
}

// 跳转配置列表
export function getConfigListAPI(id) {
  return http({
    url: '/admin/oprt/ad/link/config',
    method: 'get',
    params: {id},
  })
}
// 提交跳转配置
export function submitConfigListAPI(data) {
  return http({
    url: '/admin/oprt/ad/link/config',
    method: 'post',
    data
  })
}
// 商品列表
export function getGoodsListAPI(params) {
  return http({
    url: '/admin/goods/page',
    method: 'get',
    params
  })
}
// 分类树
export function getGoodsCategoryTreeAPI(params) {
  return http({
    url: '/admin/goods/category/tree',
    method: 'get',
    params
  })
}
